'use strict';

exports.__esModule = true;

var _media = require('../utils/media');

var baseTheme = {
  breakpoints: [_media.mediaSizes.sm, _media.mediaSizes.md, _media.mediaSizes.lg, _media.mediaSizes.xl]
};

exports.default = baseTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/theme/baseTheme.js
// module id = 528
// module chunks = 29